import { watch } from 'vue';

/**
 * Hook para manejar el cambio de página y actualizar datos.
 * @param {function} callFunction - Nombre de la función a ejecutar.
 * @param {ref} currentPage - Referencia reactiva para la página actual.
 * @param {ref} response - Referencia reactiva para la respuesta de datos.
 * @param {ref} totalElements - Referencia reactiva para el total de elementos.
 * @param {ref} query - Referencia reactiva para la consulta.
 * @param {function} route - Función para obtener la ruta actual.
 * @param {function} store - Store para obtener configuraciones (como el tamaño de página).
 */
export function usePageWatcher(callFunction, currentPage, response, totalElements, query, route, store) {
    watch(
        () => route.params.page,
        async (newPage) => {
            currentPage.value = parseInt(newPage) || 1;
            const result = await callFunction(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query);
            response.value = result;
            totalElements.value = result.total;
        }
    );
}


/**
 * Crea un watcher para observar los cambios en los parámetros de la ruta.
 *
 * @param {function} callFunction - Nombre de la función a ejecutar.
 * @param {ref} currentPage - Referencia a la página actual.
 * @param {ref} response - Referencia para almacenar la respuesta de materiales.
 * @param {ref} totalElements - Referencia para almacenar el total de elementos.
 * @param {ref} query - Referencia a la consulta.
 * @param {object} route - Objeto de ruta.
 * @param {object} store - Objeto de store Vuex.
 */
export const useSortWatcher = (callFunction, currentPage, response, totalElements, query, route, store) => {
    watch(
        () => route.params.sort,
        async (newSort) => {
            const result = await callFunction(currentPage.value, store.getters.pageSize, query.value, newSort, route.query);
            response.value = result;
            totalElements.value = result.total;
        }
    );
};

/**
 * Crea un watcher para observar los cambios en la query de la ruta
 *
 * @param {function} callFunction - Nombre de la función a ejecutar.
 * @param {ref} currentPage - Referencia a la página actual.
 * @param {ref} response - Referencia para almacenar la respuesta de materiales.
 * @param {ref} totalElements - Referencia para almacenar el total de elementos.
 * @param {ref} query - Referencia a la consulta.
 * @param {object} route - Objeto de ruta.
 * @param {object} store - Objeto de store Vuex.
 */
export const useQueryWatcher = (callFunction, currentPage, response, totalElements, query, route, store) => {
    watch(
        () => route.query,
        async () => {
            const result = await callFunction(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query);
            response.value = result;
            totalElements.value = result.total;
        }
    );
};
